<script>
	import _ from 'lodash';

	export default {
		name: 'SearchByEnter',
		data() {
			return {
				container: null,
			};
		},
		computed: {
			currPageName() {
				return this.$route.name;
			},
		},
		methods: {
			domEnterCallback(e) {
				if (
					e.key !== 'Enter' ||
					e.target.className.indexOf('search-by-enter__target') < 0
				)
					return;
				switch (this.currPageName) {
					case 'SplashManage':
					case 'ProductList':
					case 'ActivatedList':
					case 'InactivatedList':
					case 'ClosedList':
					case 'EventModify':
					case 'IngredientList':
					case 'IngredientManagement':
					case 'DuplicatedProduct':
					case 'AdminList':
						this.searching();
						break;
					case 'InitPopup':
					case 'MainLineBanner':
					case 'EventLineBanner':
					case 'ProductLineBanner':
					case 'RegisterBlock':
						this.getSearch();
						break;
					case 'PushManage':
						this.searching(0);
						break;
					case 'AdsList':
					case 'NoticeList':
					case 'ReviewReportList':
					case 'CsList':
					case 'ProductReqList':
					case 'EventsList':
					case 'BrandRecommendManage':
						this.search();
						break;
					case 'Login':
						this.login();
						break;
				}
			},
			debounce: _.debounce(function (e) {
				this.domEnterCallback(e);
			}, 100),
			setSearchByEnter() {
				this.container = document.querySelector(
					'.search-by-enter__container'
				);
				if (!this.container) return;
				this.container.removeEventListener('keyup', this.debounce);
				this.container.addEventListener('keyup', this.debounce);
			},
		},
		mounted() {
			this.$nextTick(() => {
				setTimeout(() => {
					this.setSearchByEnter();
				});
			});
		},
		beforeDestroy() {
			if (!this.container) return;
			this.container.removeEventListener('keyup', this.debounce);
		},
	};
</script>
